import { TextField } from "@mui/material"
import { ChangeEvent, useMemo } from "react";
import { NumberProperty } from "types/Property";
import { TooltipFormControl } from "./TooltipFormControl"

export type NumberFormControlProps = {
    value?: number | string,
    property: NumberProperty,
    onChange?: (newValue: number) => void
}

export function NumberFormControl({ value, property, onChange }: NumberFormControlProps) {
    const label = useMemo(() => {

        let label = property.displayName || property.name;
        if (property.readOnly)
            label += " (readonly)"
        return label;
    }, [property.name, property.readOnly, property.displayName])

    if(property.hidden){ return null; }
    
    return <TooltipFormControl property={property} >
        <TextField
            aria-label={`field-${property.name}`}
            id={`field-${property.name}`}
            data-testid={`field-${property.name}`}
            label={label}
            value={value || property.default || ''}
            onChange={handleChange}
            required={property.required}
            InputProps={{
                readOnly: property.readOnly,
            }}
            type="number"
            size='small'
            sx={{ width: '100%' }}
        />
    </TooltipFormControl>

    function handleChange(e: ChangeEvent<HTMLInputElement>) {
        if (property.readOnly) {
            console.warn(`Field ${property.name} is read-only and cannot be changed.`);
            return;
        }

        const newNumber = parseInt(e.target.value);

        if (isNaN(newNumber)) {
            console.warn(`Invalid value for field ${property.name}: ${e.target.value}`);
            return;
        }

        onChange(newNumber)
    };
}